import { makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'

export const selecOptionStyles = makeStyles(() => ({
  link: {
    color: brandColors.skyBlue6,
  },
  '&:hover': {
    color: brandColors.black,
    backgroundColor: brandColors.skyBlue2,
  },
}))
